import { Clock, EyeOff, TrendingDown, UserX } from "lucide-react";

const PROBLEMS = [
  {
    icon: Clock,
    title: "You're out of time",
    text: "Between calls, follow-ups, and family, marketing keeps getting bumped to \"later.\"",
  },
  {
    icon: EyeOff,
    title: "Inconsistent visibility",
    text: "You post when you can. Prospects can\u2019t remember you if you\u2019re not showing up every week.",
  },
  {
    icon: UserX,
    title: "Unpredictable lead flow",
    text: "Some months you have prospects. Most months you don\u2019t. Recurring income shouldn\u2019t feel this fragile.",
  },
  {
    icon: TrendingDown,
    title: "Growing alone is slow",
    text: "Doing content, lead-gen, outreach, and closing by yourself caps how fast you can scale.",
  },
];

export default function Problem() {
  return (
    <section
      data-testid="wc-problem"
      className="relative bg-white py-20 sm:py-28"
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 bg-[#f3efff] text-[#673dfc] font-nav font-semibold text-xs rounded-full px-3 py-1 mb-4">
            The reality
          </div>
          <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#30265b]">
            Most Brand Affiliates aren&apos;t stuck because of talent. They&apos;re
            stuck because they&apos;re doing it all alone.
          </h2>
          <p className="mt-5 text-lg text-gray-600 leading-relaxed">
            Building a recurring income business takes consistent marketing,
            consistent lead flow, and consistent follow-up. Doing that solo,
            week after week, is where most affiliates plateau.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-12">
          {PROBLEMS.map((p) => (
            <div
              key={p.title}
              className="rounded-2xl border border-gray-100 p-6 bg-white hover:shadow-md hover:-translate-y-1 transition-transform duration-300"
            >
              <div className="w-11 h-11 rounded-xl bg-[#f3efff] grid place-items-center text-[#673dfc] mb-4">
                <p.icon size={20} />
              </div>
              <div className="font-display font-bold text-lg text-[#30265b]">
                {p.title}
              </div>
              <p className="mt-2 text-sm text-gray-600 leading-relaxed">
                {p.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
